import InvoicePortalConfirmation from './InvoicePortalConfirmation';

export default InvoicePortalConfirmation;
